import { motion } from "framer-motion";

const EASE = [0.19, 1, 0.22, 1];

export default function Reveal({ children, delay = 0, y = 32, className = "", once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.15 }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHead({ kicker, title, sub, align = "center" }) {
    const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
    return (
        <Reveal className={`flex flex-col gap-4 ${alignCls}`}>
            {kicker ? <span className="kicker">{kicker}</span> : null}
            <h2 className="headline text-4xl sm:text-5xl lg:text-6xl text-white">{title}</h2>
            {sub ? <p className="max-w-2xl text-base md:text-lg text-slate-400">{sub}</p> : null}
        </Reveal>
    );
}

export { EASE };
